/**
 * Ring PRO color name and image for variant/color selection (color picker).
 * Assets: web_v2/ring-pro/buy-v2/thumbs/pro-{color}-thumb.png
 */
import { RingProColors } from './constants';

type TFunction = (key: string) => string;

export type RingProColorNameImage = {
  image: string;
  shop: string;
  swatch: string;
  name: string;
  tag: string | null;
};

const THUMB_BASE = 'web_v2/ring-pro/buy-v2/thumbs';

const RING_PRO_COLOR_DIR: Record<RingProColors, string> = {
  [RingProColors.GOLD]: 'gold',
  [RingProColors.SILVER]: 'silver',
  [RingProColors.BLACK]: 'black',
  [RingProColors.TITANIUM]: 'titanium',
};

export function getRingProColorNameImages(
  t: TFunction,
): Record<RingProColors, RingProColorNameImage> {
  return {
    [RingProColors.GOLD]: {
      image: `${THUMB_BASE}/pro-${
        RING_PRO_COLOR_DIR[RingProColors.GOLD]
      }-thumb.png/w_400`,
      shop: `web_v2/shop/pro/bionic-gold.png`,
      swatch: 'web_v2/ring-buy/ring-air-color-swatch/bionic-gold.png',
      name: t('ring-pro:ring-pro.productSelection.GOLD') || 'Bionic Gold',
      tag: null,
    },
    [RingProColors.SILVER]: {
      image: `${THUMB_BASE}/pro-${
        RING_PRO_COLOR_DIR[RingProColors.SILVER]
      }-thumb.png/w_400`,
      shop: `web_v2/shop/pro/space-silver.png`,
      swatch: `web_v2/ring-buy/ring-air-color-swatch/space-silver.png`,
      name: t('ring-pro:ring-pro.productSelection.SILVER') || 'Space Silver',
      tag: null,
    },
    [RingProColors.BLACK]: {
      image: `${THUMB_BASE}/pro-${
        RING_PRO_COLOR_DIR[RingProColors.BLACK]
      }-thumb.png/w_400`,
      shop: `web_v2/shop/pro/aster-black.png`,
      swatch: `web_v2/ring-buy/ring-air-color-swatch/aster-black.png`,
      name: t('ring-pro:ring-pro.productSelection.BLACK') || 'Aster Black',
      tag: null,
    },
    [RingProColors.TITANIUM]: {
      image: `${THUMB_BASE}/pro-${
        RING_PRO_COLOR_DIR[RingProColors.TITANIUM]
      }-thumb.png/w_400`,
      shop: `web_v2/shop/pro/raw-titanium.png`,
      swatch: `web_v2/ring-buy/ring-air-color-swatch/raw-titanium.png`,
      name: t('ring-pro:ring-pro.productSelection.TITANIUM') || 'Raw Titanium',
      tag: null,
    },
  };
}

/** No store-specific tag overrides for PRO; use for getRingProColorTag. */
export function getRingProColorTag(
  _color: RingProColors,
  _store?: unknown,
): string | null {
  return null;
}
